﻿import UserSetupPage from "./userSetupPage";
import TaskSchedulerPage from "./taskSchedulerPage";

if (!window.userSetupPage) {
    window.userSetupPage = new UserSetupPage();
}

if (!window.taskSchedulerPage) {
    window.taskSchedulerPage = new TaskSchedulerPage();
}